import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InnerImageZoom from 'react-inner-image-zoom';
import StandardModal from 'components/consumer/StandardModal';
import PDPShownIn from 'components/consumer/PDP/PDPShownIn';
import useKeyboardControlForIndexedItems from 'hooks/useKeyboardControlForIndexedItems';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import PDPProductIntroVideo from '../PDPDesktopHeroGallery/PDPProductIntroVideo';
import PDPDesktopFullScreenGallery2Thumbnail from './components/PDPDesktopFullScreenGallery2Thumbnail';
import usePhotoWidth from './usePhotoWidth';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
const PDPDesktopFullScreenGallery2UI = t0 => {
  const $ = _c(96);
  const {
    isEditOrder: t1,
    enableCrops,
    handleVideoSelected: t2,
    imageLocation,
    introVideoId: t3,
    isOpen,
    isVideoSelected: t4,
    onClose,
    photos: t5,
    photoSrc: t6,
    productName,
    selectedPhotoIndex,
    setSelectedPhotoIndex,
    videoPosterUrl,
    videoThumbnailUrl,
    viewGalleryImageEvent
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const handleVideoSelected = t2 === undefined ? _temp : t2;
  const introVideoId = t3 === undefined ? "" : t3;
  const isVideoSelected = t4 === undefined ? false : t4;
  let t7;
  if ($[0] !== t5) {
    t7 = t5 === undefined ? [] : t5;
    $[0] = t5;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const photos = t7;
  let t8;
  if ($[2] !== t6) {
    t8 = t6 === undefined ? {} : t6;
    $[2] = t6;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const photoSrc = t8;
  const thumbnailWrapperRef = useRef(null);
  const selectedThumbnailRef = useRef(null);
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [];
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  const [items, setItems] = useState(t9);
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);
  const [isZoomedIn, setIsZoomedIn] = useState(false);
  let t10;
  let t11;
  if ($[5] !== introVideoId || $[6] !== photos) {
    t10 = () => {
      const photoItems = photos.map(_temp2);
      const videoItem = {
        id: introVideoId,
        itemType: "video"
      };
      const updatedItems = introVideoId && photoItems.length ? [photoItems[0], videoItem, ...photoItems.slice(1)] : photoItems;
      setItems(updatedItems);
    };
    t11 = [photos, introVideoId];
    $[5] = introVideoId;
    $[6] = photos;
    $[7] = t10;
    $[8] = t11;
  } else {
    t10 = $[7];
    t11 = $[8];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[9] !== isVideoSelected || $[10] !== items || $[11] !== selectedPhotoIndex) {
    t12 = () => {
      if (isVideoSelected) {
        const videoItemIndex = items.findIndex(_temp3);
        if (videoItemIndex !== -1) {
          setSelectedItemIndex(videoItemIndex);
        }
      } else {
        const photoItemIndex = items.findIndex(item_0 => item_0.itemType === "photo" && item_0.photoIndex === selectedPhotoIndex);
        if (photoItemIndex !== -1) {
          setSelectedItemIndex(photoItemIndex);
        }
      }
    };
    t13 = [selectedPhotoIndex, items, isVideoSelected];
    $[9] = isVideoSelected;
    $[10] = items;
    $[11] = selectedPhotoIndex;
    $[12] = t12;
    $[13] = t13;
  } else {
    t12 = $[12];
    t13 = $[13];
  }
  useEffect(t12, t13);
  let t14;
  if ($[14] !== handleVideoSelected || $[15] !== imageLocation || $[16] !== items || $[17] !== photos.length || $[18] !== setSelectedPhotoIndex || $[19] !== viewGalleryImageEvent) {
    t14 = index_0 => {
      setIsZoomedIn(false);
      const updatedItem = items[index_0];
      if (updatedItem.itemType === "video") {
        handleVideoSelected(true);
      } else {
        handleVideoSelected(false);
        setSelectedPhotoIndex(updatedItem.photoIndex);
        viewGalleryImageEvent?.({
          imageLocation,
          imageFilename: updatedItem.src?.split("/").pop() || "",
          position: updatedItem.photoIndex,
          totalImages: photos.length
        });
      }
      setTimeout(() => {
        const thumbnailWrapper = thumbnailWrapperRef?.current;
        const selectedThumbnail = selectedThumbnailRef?.current;
        thumbnailWrapper?.scrollTo({
          top: (selectedThumbnail?.offsetTop || 0) - (thumbnailWrapper.clientHeight || 64) / 2,
          behavior: "smooth"
        });
      }, 10);
    };
    $[14] = handleVideoSelected;
    $[15] = imageLocation;
    $[16] = items;
    $[17] = photos.length;
    $[18] = setSelectedPhotoIndex;
    $[19] = viewGalleryImageEvent;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  const setSelectedItemAndScroll = t14;
  const numberOfItems = photos?.length ?? 0;
  let t15;
  if ($[21] !== isOpen || $[22] !== numberOfItems || $[23] !== selectedItemIndex || $[24] !== setSelectedItemAndScroll) {
    t15 = {
      isEnabled: isOpen,
      numberOfItems,
      selectedIndex: selectedItemIndex,
      setSelectedIndex: setSelectedItemAndScroll
    };
    $[21] = isOpen;
    $[22] = numberOfItems;
    $[23] = selectedItemIndex;
    $[24] = setSelectedItemAndScroll;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  useKeyboardControlForIndexedItems(t15);
  const maxPhotoWidth = usePhotoWidth();
  let t16;
  if ($[26] !== enableCrops || $[27] !== items || $[28] !== selectedItemIndex || $[29] !== setSelectedItemAndScroll || $[30] !== videoPosterUrl || $[31] !== videoThumbnailUrl) {
    t16 = items.map((t17, itemIndex) => {
      const {
        cropData,
        type,
        id,
        itemType,
        src
      } = t17;
      const isItemSelected = itemIndex === selectedItemIndex;
      return <PDPDesktopFullScreenGallery2Thumbnail cropData={cropData} enableCrops={enableCrops} isItemSelected={isItemSelected} itemIndex={itemIndex} itemType={itemType} key={`${id}-${itemType}`} selectedThumbnailRef={selectedThumbnailRef} setSelectedItemAndScroll={setSelectedItemAndScroll} src={src} type={type} videoPosterUrl={videoPosterUrl} videoThumbnailUrl={videoThumbnailUrl} />;
    });
    $[26] = enableCrops;
    $[27] = items;
    $[28] = selectedItemIndex;
    $[29] = setSelectedItemAndScroll;
    $[30] = videoPosterUrl;
    $[31] = videoThumbnailUrl;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t16) {
    t17 = <div className="max-h-[calc(90vh_-_4rem)] min-w-[315px] overflow-y-auto w-[325px]" ref={thumbnailWrapperRef}><div className="grid gap-[7px_7px] grid-cols-[142px_142px] mb-px min-w-[300px] w-1/4">{t16}</div></div>;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== maxPhotoWidth) {
    t18 = {
      maxWidth: maxPhotoWidth
    };
    $[35] = maxPhotoWidth;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== productName) {
    t19 = <div className="text-xl font-bold text-gray mb-4 max-w-full text-center w-[2000px]">{productName}</div>;
    $[37] = productName;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== isVideoSelected) {
    t20 = classNames("object-contain object-center select-none p-0 max-w-full relative flex", {
      "w-full": isVideoSelected
    });
    $[39] = isVideoSelected;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== isZoomedIn) {
    t21 = classNames("items-center border-0 bottom-0 flex justify-start opacity-0 absolute top-0 transition-[opacity_.3s] w-[12%] z-[1] mx-0 my-auto focus-visible:opacity-100 focus-visible:outline-offset-[-5px] hover:opacity-100 [background:linear-gradient(90deg,rgba(0,0,0,.35)__.06%,hsla(0,0%,76.9%,0)__99.94%)] left-0  h-full", {
      hidden: isZoomedIn
    });
    $[41] = isZoomedIn;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== numberOfItems || $[44] !== selectedItemIndex || $[45] !== setSelectedItemAndScroll) {
    t22 = () => {
      const previousIndex = selectedItemIndex - 1;
      if (previousIndex < 0) {
        setSelectedItemAndScroll(numberOfItems - 1);
      } else {
        setSelectedItemAndScroll(previousIndex);
      }
    };
    $[43] = numberOfItems;
    $[44] = selectedItemIndex;
    $[45] = setSelectedItemAndScroll;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  let t24;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <IconArrowRightSimple width={22} height={40} className="ml-2.5 -rotate-180" color="white" />;
    t24 = <VisuallyHidden>Previous image</VisuallyHidden>;
    $[47] = t23;
    $[48] = t24;
  } else {
    t23 = $[47];
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t21 || $[50] !== t22) {
    t25 = <button type="button" className={t21} onClick={t22}>{t23}{t24}</button>;
    $[49] = t21;
    $[50] = t22;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== isVideoSelected || $[53] !== photoSrc) {
    t26 = !isVideoSelected && photoSrc?.zoomSrc ? <InnerImageZoom height={600} src={photoSrc.src} zoomSrc={photoSrc.zoomSrc} zoomPreload={true} hasSpacer={true} hideCloseButton={true} hideHint={true} afterZoomIn={() => {
      setIsZoomedIn(true);
    }} afterZoomOut={() => {
      setIsZoomedIn(false);
    }} /> : null;
    $[52] = isVideoSelected;
    $[53] = photoSrc;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== introVideoId || $[56] !== isVideoSelected) {
    t27 = isVideoSelected && introVideoId ? <PDPProductIntroVideo variant="PDPDesktopFullScreenGallery2" videoId={introVideoId} /> : null;
    $[55] = introVideoId;
    $[56] = isVideoSelected;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] !== isZoomedIn) {
    t28 = classNames("items-center border-0 bottom-0 flex opacity-0 absolute top-0 transition-[opacity_.3s] w-[12%] z-[1] mx-0 my-auto focus-visible:opacity-100 focus-visible:outline-offset-[-5px] hover:opacity-100 [background:linear-gradient(270deg,rgba(0,0,0,.35)__.06%,hsla(0,0%,76.9%,0)__99.94%)] justify-end right-0 h-full", {
      hidden: isZoomedIn
    });
    $[58] = isZoomedIn;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== numberOfItems || $[61] !== selectedItemIndex || $[62] !== setSelectedItemAndScroll) {
    t29 = () => {
      const nextIndex = selectedItemIndex + 1;
      if (nextIndex >= numberOfItems) {
        setSelectedItemAndScroll(0);
      } else {
        setSelectedItemAndScroll(nextIndex);
      }
    };
    $[60] = numberOfItems;
    $[61] = selectedItemIndex;
    $[62] = setSelectedItemAndScroll;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  let t31;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <IconArrowRightSimple width={22} height={40} className="mr-2.5" color="white" />;
    t31 = <VisuallyHidden>Next image</VisuallyHidden>;
    $[64] = t30;
    $[65] = t31;
  } else {
    t30 = $[64];
    t31 = $[65];
  }
  let t32;
  if ($[66] !== t28 || $[67] !== t29) {
    t32 = <button type="button" className={t28} onClick={t29}>{t30}{t31}</button>;
    $[66] = t28;
    $[67] = t29;
    $[68] = t32;
  } else {
    t32 = $[68];
  }
  let t33;
  if ($[69] !== t20 || $[70] !== t25 || $[71] !== t26 || $[72] !== t27 || $[73] !== t32) {
    t33 = <div className={t20}>{t25}{t26}{t27}{t32}</div>;
    $[69] = t20;
    $[70] = t25;
    $[71] = t26;
    $[72] = t27;
    $[73] = t32;
    $[74] = t33;
  } else {
    t33 = $[74];
  }
  let t34;
  if ($[75] !== isEditOrder || $[76] !== isVideoSelected || $[77] !== onClose || $[78] !== photos || $[79] !== productName || $[80] !== selectedPhotoIndex) {
    t34 = !isVideoSelected && <div className="flex-[1_1] flex items-center justify-end"><div className="PDPDesktopFullScreenGallery2__MainPhoto-shownin"><PDPShownIn fullWidth={true} isEditOrder={isEditOrder} optionId={photos?.[selectedPhotoIndex]?.optionId} valueId={photos?.[selectedPhotoIndex]?.valueId} upholsteryName={photos?.[selectedPhotoIndex]?.upholsteryName} onSelection={() => {
          onClose(true);
        }} layout="greyBG" showInactiveUpholstery={true} productName={productName} /></div></div>;
    $[75] = isEditOrder;
    $[76] = isVideoSelected;
    $[77] = onClose;
    $[78] = photos;
    $[79] = productName;
    $[80] = selectedPhotoIndex;
    $[81] = t34;
  } else {
    t34 = $[81];
  }
  let t35;
  if ($[82] !== t34) {
    t35 = <div className="flex flex-row mt-4 w-full">{t34}</div>;
    $[82] = t34;
    $[83] = t35;
  } else {
    t35 = $[83];
  }
  let t36;
  if ($[84] !== t18 || $[85] !== t19 || $[86] !== t33 || $[87] !== t35) {
    t36 = <div className="items-center flex flex-col ml-6"><div className="items-center bg-transparent border-0 flex flex-col flex-1 justify-between max-h-[calc(90vh_-_4rem)] overflow-y-hidden" style={t18}>{t19}{t33}{t35}</div></div>;
    $[84] = t18;
    $[85] = t19;
    $[86] = t33;
    $[87] = t35;
    $[88] = t36;
  } else {
    t36 = $[88];
  }
  let t37;
  if ($[89] !== t17 || $[90] !== t36) {
    t37 = <div className="flex flex-row justify-center w-full">{t17}{t36}</div>;
    $[89] = t17;
    $[90] = t36;
    $[91] = t37;
  } else {
    t37 = $[91];
  }
  let t38;
  if ($[92] !== isOpen || $[93] !== onClose || $[94] !== t37) {
    t38 = <div className="w-full"><StandardModal isOpen={isOpen} onClose={onClose} theme="light" size="xl">{t37}</StandardModal></div>;
    $[92] = isOpen;
    $[93] = onClose;
    $[94] = t37;
    $[95] = t38;
  } else {
    t38 = $[95];
  }
  return t38;
};
PDPDesktopFullScreenGallery2UI.propTypes = {
  enableCrops: PropTypes.bool,
  handleVideoSelected: PropTypes.func,
  imageLocation: PropTypes.string,
  introVideoId: PropTypes.string,
  isEditOrder: PropTypes.bool,
  isOpen: PropTypes.bool,
  isVideoSelected: PropTypes.bool,
  onClose: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    cropData: PropTypes.object,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    optionId: PropTypes.number,
    src: PropTypes.string,
    type: PropTypes.oneOf(['buildyourown', 'configuration', 'dimensional', 'studio']),
    upholsteryName: PropTypes.string,
    valueId: PropTypes.number
  })),
  photoSrc: PropTypes.shape({
    src: PropTypes.string,
    zoomSrc: PropTypes.string
  }),
  productName: PropTypes.string,
  selectedPhotoIndex: PropTypes.number,
  setSelectedPhotoIndex: PropTypes.func,
  videoPosterUrl: PropTypes.string,
  videoThumbnailUrl: PropTypes.string,
  viewGalleryImageEvent: PropTypes.func
};
export default PDPDesktopFullScreenGallery2UI;
function _temp() {}
function _temp2(photo, index) {
  return {
    cropData: photo.cropData,
    type: photo.type,
    id: photo.id,
    itemType: "photo",
    optionId: photo.optionId,
    photoIndex: index,
    src: photo.src,
    upholsteryName: photo.upholsteryName,
    valueId: photo.valueId
  };
}
function _temp3(item) {
  return item.itemType === "video";
}